module.exports = __webpack_public_path__ + "img/winner-bg.e34b9681.png";